import ReactDOM from 'react-dom/client'
import { QueryClientProvider } from '@tanstack/react-query'
import { queryClient } from './lib/queryClient'
import { ToastContainer } from 'react-toastify'
import { disableCache } from '@iconify/react'
import App from './App.jsx'
import './index.css'
import 'react-toastify/dist/ReactToastify.css'

// Disable Iconify API requests - icons will be bundled
disableCache('all')

ReactDOM.createRoot(document.getElementById('root')).render(
  <QueryClientProvider client={queryClient}>
    <App />
    <ToastContainer
      position="top-right"
      autoClose={3000}
      hideProgressBar={false}
      newestOnTop={false}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      theme="light"
    />
  </QueryClientProvider>,
)
